var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-box"},[_c('ContactDetails',{attrs:{"contact":_vm.contact,"editable":_vm.editable}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }